@if (form) {
    <div [formGroup]="form" appearance="outline" color="primary">
        <lib-range-picker [formControlName]="this.key" />
    </div>
} @else {
    <div appearance="outline" color="primary">
        <lib-range-picker [fieldKey]="this.key" [onChange]="this.onChange" [className]="this.className"/>
    </div>
}
